import CustomAccardion from './CustomAccardion';
import './CustomAccardion.scss';

export default CustomAccardion;
